import { useStaticQuery, graphql } from "gatsby"

import useClanLocalityData from "../hooks/useClanLocalityData"
import useClanKinshipData from "../hooks/useClanKinshipData"
import useBookData from "../hooks/useBookData"

const query = graphql`
	query legendsQuery {
		allCclansLocalityCsv {
			distinct(field: locality)
		}
	}
`

function getYear(year) {
  year = /[0-9]{4}/.exec(year)
  return year ? year[0] : "?"
}

function urlExtract(s) {
	const regex = /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
	const extracted = s.match(regex)
	// return extracted?.join("\n")
	return extracted
}

export default function MapData() {
	const {allCclansLocalityCsv : { distinct : legends }} = useStaticQuery(query)

	const localityData = useClanLocalityData()
  const kinshipData  = useClanKinshipData()
  const bookData = useBookData()

	const data = localityData.concat(kinshipData)
		.map(data => ({
			...data,
			website: urlExtract(data.website),
			yearest: getYear(data.yearest),
			publications: bookData.filter(book => book.clanId === data.id && book.type === data.type)
		}))

	return [ data, [ ...new Set(legends.map(e => e.toLowerCase())) ] ]
}
